var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partners"},[_c('h1',{staticClass:"partners__title"},[_vm._v(_vm._s(_vm.$t('partners')))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partners__content"},[_c('div',{staticClass:"partners__content-wrapper"},[_c('div',{staticClass:"partners__content-wrapper-images"},[_c('img',{attrs:{"src":require("@/assets/images/a-pro-logo.png")}})])])])
}]

export { render, staticRenderFns }